<template>
  <Toast/>
  <component :is="layout" v-if="layout == 'login' || mainStore().globalView">
    <router-view/>
  </component>
</template>
<script>

import main from "@/layout/layoutMain";
import login from "@/layout/layoutLogin";
import {mainStore} from "@/store/main";
import {getConditionsApi} from "@/api/profile";
import {usePrimeVue} from "primevue/config";
import {en} from '@/assets/localPrimeVue/en.json';
import {ru} from '@/assets/localPrimeVue/ru.json';

const messages = {
  en,
  ru
}

export default {
  components: {main, login},
  data() {
    return {
      primevue: null
    }
  },
  created() {
    this.versionDisplay()
    window.addEventListener("resize", this.versionDisplay);
    this.primevue = usePrimeVue();
    mainStore().setGlobalLoading(true)
  },
  async mounted() {

  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'login'
    },
    profile() {
      return mainStore().infoProfile
    }
  },
  watch: {
    '$i18n.locale'() {
      this.primevue.config.locale = messages[this.$i18n.locale] || messages.en
    },
    layout() {
      if (this.layout === 'main') {
        this.getConditions()
      }
    },
  },
  methods: {
    mainStore,
    getConditions() {
      getConditionsApi().then((resp) => {
        mainStore().setType(resp.data.items)
        mainStore().setGlobalView(true)
      }, (error) => {
      })
    },
    versionDisplay() {
      mainStore().setVersionDisplay(window.innerWidth)
    },
  }
}

</script>

<style lang="scss">
#app {
  height: 100vh;
}
</style>
